import { render } from "./SeoContentList.vue?vue&type=template&id=565d4bac"
import script from "./SeoContentList.vue?vue&type=script&lang=js"
export * from "./SeoContentList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__